import { useEffect, useContext, createContext } from "react";
import { useContextKeycloak } from "@/app/module/keycloak/index";
import { useLicenseAgreement } from "./license-agreement-hooks";

type ContextLicenseAgreementType = Omit<
  ReturnType<typeof useLicenseAgreement>,
  "fetchLicenseAgreement"
>;
export const licenseAgreementContext =
  createContext<ContextLicenseAgreementType | null>(null);

export function useContextLicenseAgreement() {
  const context = useContext(licenseAgreementContext);

  if (!context) {
    throw new Error(
      "useContextLicenseAgreement must be used within a ContextLicenseAgreementProvider",
    );
  }

  return context;
}

export function ContextLicenseAgreementProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const contextValues = useLicenseAgreement();
  const { mlaStatus, fetchLicenseAgreement } = contextValues;
  const { authorize } = useContextKeycloak();

  useEffect(() => {
    if (authorize && mlaStatus === "init") {
      Promise.all([fetchLicenseAgreement()]).catch(console.error);
    }
  }, [authorize, mlaStatus]);

  if (authorize && mlaStatus === "init") {
    return null;
  }

  return (
    <licenseAgreementContext.Provider value={contextValues}>
      {children}
    </licenseAgreementContext.Provider>
  );
}
